import { Theme } from "@fluentui/react-components";
import { createContext } from "react";

interface ThemeContextProps {
    theme: Theme;
    setTheme:  React.Dispatch<React.SetStateAction<Theme>>
}

export const ThemeContext = createContext({} as ThemeContextProps);
